import { render, staticRenderFns } from "./TanzaniaDetail.vue?vue&type=template&id=0d6b055c&"
import script from "./TanzaniaDetail.vue?vue&type=script&lang=js&"
export * from "./TanzaniaDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports